export default "__VITE_ASSET__DVf_bUyY__ 778w";